import { useMutation } from "@tanstack/react-query";

import { getBrisbaneReport } from "./fetch";

export const useGetBrisbaneReport = ({ onSuccess }) => {
  return useMutation({
    mutationKeyKey: ["brisbaneReport"],
    mutationFn: getBrisbaneReport,
    onSuccess: (resp) => {
      if (onSuccess) onSuccess(resp);
    },
  });
};